var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUserLoaded)?_c(_vm.homeView,{tag:"component"}):_c('page-layout',{attrs:{"header":_vm.isMobile,"loaded":false,"title":"Home"}})
}
var staticRenderFns = []

export { render, staticRenderFns }